<template>
  <div class="container">
    <el-dialog title="" :visible.sync="isShow">
      <div class="content-box form-box">
        <div class="content-info">
          <div class="content-label flex flex-column flex-y-center">
            <span class="content-label-text">{{title}}</span>
            <span class="content-label-value">{{title == '反馈留言' ? 'Feedback message' : 'Register Now'}}</span>
          </div>
          <el-form ref="form" :model="form" style="form-modal" :rules="rules">
            <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话：" :label-width="formLabelWidth" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="留言：" :label-width="formLabelWidth" prop="message">
              <el-input v-model="form.message" placeholder="请输入留言" maxlength="30"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer flex flex-x-center">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPath:'',//当前路由
      dialogFormVisible: false,
      form: {
        name: '',
        phone: '',
        message:''
      },
      formLabelWidth: '70px',
      isShow:false,
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入正确的手机号码', trigger: 'blur' }],
        message: [{ required: true, message: '请输入留言', trigger: 'blur' }],
      },
    }
  },
  watch:{
    isShow(val){
      if(val){
        this.form = {}
      }
    }
  },
  props:{
    title:{
      type:String,
      default:''
    },
    uploadData:Object
  },
  methods:{
    handleSubmit(){
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$api[this.title == '反馈留言' ? 'feedbackMessage' : 'subscribe']({...this.form,...this.uploadData}).then(res=> {
            if(res.data.code == 200){
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              this.isShow = false
            }else{
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'warning'
              });
            }
          })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media screen and (max-width: 1400px) {
  .container{
    .form-modal{
      width:100%;
      margin:auto
    }
    .content-box{
      width: 100%;  
      .content-info{
        min-width:100% !important;
        width: 100% !important;
      }
    }
  }
}
@media screen and (max-width: 1600px ) and (min-width:1200px) {
  .container{
    .form-modal{
      width:100%;
      margin:auto
    }
    .content-box{
      width: 100%;  
      .content-info{
        min-width:100% !important;
        width: 100% !important;
      }
    }
  }
}

.container{
  .form-modal{
    width:600px;
    margin:auto
  }
  .content-box{
    width: 100%;  
    .content-info{
      min-width: 600px;
      width: 600px;
      margin: auto;
      .content-label{
        margin-bottom: 70px;
        &::after{
          content: "";
          width: 60px;
          height: 5px;
          background-color: #00AD60;
        }
        .content-label-text{
          font-size: 28px;
          font-weight: bold;
        }
        .content-label-value{
          display: block;
          font-size: 18px;
          margin: 15px 0;
        }
      }
    }
  }
  
  .affix-container{
    width: 110px;
    height: 310px;
    position: fixed;
    right: 0;
    top: 50%;
    background-color: #ffffff;
    box-shadow: 0px 4px 35px 0px rgba(0, 70, 5, 0.1);
    border-radius: 10px;
    z-index: 999;
    padding: 0 8px;
    .affix-box{
      padding: 20px 0;
      img{
        width: 36px;
        height: 36px;
        margin-bottom: 8px;
      }
      span{
        font-size: 14px;
      }
    }
  }
}

.tel-box{
  padding: 10px 0;
  >div{
    margin-bottom: 10px;
    .tel-title{
      width: 70px;
      text-align: left;
      font-size: 16px;
      margin-right: 10px;
    }
    .tel-num{
      font-size: 24px;
      font-weight: bold;
      color: #15A367;
    }
  }
  >div:last-child{
    margin-bottom: 0;
  }
}

.scan-code{
  padding: 10px;
  img{
    width: 144px;
    height: 144px;
    margin-bottom: 16px;
  }
  span{
    font-size: 16px;
  }
}
.dialog-footer{
  padding: 30px 0;
  button{
    width: 200px;
    height: 54px;
    font-size: 16px;
    color: #ffffff !important;
    background-image: linear-gradient(to right, #51d5c8  , #39d77a);
    border: none;
    border-radius: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/myModal.vue